import { fromJS, Map } from 'immutable';

export function request(state, { id }) {
    let cancel = state.get('cancel') || Map();

    cancel = cancel.set(id, Map({
        state: 'IN_PROGRESS'
    }));

    return state.set('cancel', cancel);
}

export function error(state, { id, errors }) {
    let cancel = state.get('cancel') || Map();

    cancel = cancel.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('cancel', cancel);
}

export function finish(state, { id, data }) {
    let cancel = state.get('cancel') || Map();

    cancel = cancel.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items') || Map();
    items = items.set(id, fromJS(data));

    return state
        .set('items', items)
        .set('cancel', cancel);
}
